import { useEffect } from "react";
import { useLocation } from "react-router-dom"
import ReactPixel from "react-facebook-pixel";
import { useGtm } from 'hooks/useGtm';
import FepSvcKindSet from "./PageDesc";
import { useDispatch} from 'react-redux';
import { PageSetStateChng ,AppDispatch } from 'Stores/PageSetReducer';;

const RouteChngTracker = () => {
    const location = useLocation();
    const { push: gtmPush } = useGtm();
    const fepSvcKind:string = FepSvcKindSet(location.pathname.toLowerCase());
    const PIXEL_ID = process.env.REACT_APP_PIXEL_ID;
    const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {
        if (PIXEL_ID) {
            ReactPixel.init(PIXEL_ID);
        }
    }, [PIXEL_ID]);

    useEffect(() => {
        dispatch(PageSetStateChng(fepSvcKind));
    }, [dispatch, fepSvcKind]);

    useEffect(() => {
         ReactPixel.pageView();
         gtmPush('page_view', {
            page_path: location.pathname,
            page_search: location.search,
            page_title: document.title});
     }, [location.pathname, location.search, gtmPush]);

    return null;
}

export default RouteChngTracker;